import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { WEB_REPORTS_URL } from 'config/constants';
import { FormattedMessage } from 'ui/i18n';

import './WebReportsLink.scss';

@observer
export default class WebReportsLink extends Component {
	render() {
		return (
			<div className="WebReportsLink">
				<div id="WebReportsLinkId">
					<span>
						<FormattedMessage id="orderHistory.webReports" />

						<a href={WEB_REPORTS_URL} target="_blank">
							<FormattedMessage id="orderHistory.webReportsLink" />
						</a>
					</span>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/WebReportsLink/index.js